/**
 * Application-wide constants
 */

export const CACHE_DURATIONS = {
  STARS: 5 * 60 * 1000, // 5 minutes
  MEMBERS: 3 * 60 * 1000, // 3 minutes
  TRELLO_AUTH: 24 * 60 * 60 * 1000, // 24 hours
} as const;

export const COLLECTION_NAMES = {
  LEADS: 'leads',
  STARS: 'stars',
  MEMBERS: 'members',
  TRELLO_TRACKING: 'trelloTracking',
  LEAD_GENERATION_STATUS: 'leadGenerationStatus',
  USERS: 'users',
  USER_SETTINGS: 'userSettings',
  USERNAMES: 'usernames',
  COMPANIES: 'companies',
  EVENTS: 'events',
  EVENT_BATCHES: 'eventBatches',
} as const;

export const BUTTON_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
} as const;

export const DASHBOARD_VIEWS = {
  ALL: 'all',
  STARRED: 'starred',
  MEMBER: 'member',
} as const;

export const METRIC_LABELS = {
  aiMlHiring: 'AI/ML Hiring',
  aiBudget: 'AI Budget',
  aiMlProductPotential: 'AI/ML Product Potential',
  eventAttendance: 'Event Attendance',
  aiMlRelatedProjects: 'AI/ML Projects',
  organizationalMoves: 'Organizational Moves',
} as const;

export const POPUP_WINDOW_OPTIONS = {
  TRELLO_AUTH: 'width=600,height=700,scrollbars=yes,resizable=yes',
} as const;